import { Box, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { DiagonalArrowsIcon } from "../../../../../assets/icons";
import { OperatingManualStyleContext } from "../../../../../contexts/OperatingManualStyleContext";
import Image3 from "../../../../../assets/images/operating-manual/3/live-updates.png";
import Image3French from "../../../../../assets/images/operating-manual/3/live-updates-fr.png";
import Image4 from "../../../../../assets/images/operating-manual/3/live-updates2.png";
import Image4French from "../../../../../assets/images/operating-manual/3/live-updates2-fr.png";
import Image5 from "../../../../../assets/images/operating-manual/3/live-updates3.png";
import Image5French from "../../../../../assets/images/operating-manual/3/live-updates3-fr.png";
import { useTranslation } from "react-i18next";

const LiveUpdatePage = () => {
  const { sectionContainerStyle } = useContext(OperatingManualStyleContext);
  const { t } = useTranslation();

  const imgAttributes = [
    [Image3, Image3French],
    [Image4, Image4French],
    [Image5, Image5French],
  ];

  return (
    <div>
      <Box sx={{ ...sectionContainerStyle, padding: 3 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            background:
              "linear-gradient(102deg, #5d5cfe -17.62%, #996ad2 30.87%, #f18e8e 87.31%)",
            color: "white",
            p: 1,
            pl: 4,
            borderRadius: 2,
            mb: 3,
            boxShadow: "0px 0.625rem 3rem rgba(0, 0, 0, 0.06)",
          }}
        >
          <Typography id="live-update-page" variant="h6" fontWeight="bold">
            {t(`operating_manual_portal_live_update_header`)}
          </Typography>
        </Box>

        <div className="mx-auto max-w-4xl">
          <Grid
            container
            spacing={4}
            justifyContent="center"
            alignItems="center"
          >
            {/* Live Update Page Section */}
            <Grid item xs={12}>
              <Box sx={{ display: "inline-block", alignItems: "center" }}>
                {t(`operating_manual_portal_live_update_description1`)}
                <Box display="inline-block" px="8px">
                  <Box
                    height="40px"
                    width="40px"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    backgroundColor="#FFF"
                  >
                    <DiagonalArrowsIcon color="#000" />
                  </Box>
                </Box>
                {t(`operating_manual_portal_live_update_description1_2`)}
              </Box>
              <Box
                component="img"
                src={imgAttributes[0][t("operating_manual_image_index")]}
                alt="Live Updates"
                sx={{
                  width: "100%",
                  borderRadius: 1,
                  display: "block",
                  mt: 2,
                }}
              />
              <Box
                component="img"
                src={imgAttributes[1][t("operating_manual_image_index")]}
                alt="Live Updates Modal"
                sx={{
                  width: "100%",
                  borderRadius: 1,
                  display: "block",
                  mt: 2,
                }}
              />
              <Box
                component="img"
                src={imgAttributes[2][t("operating_manual_image_index")]}
                alt="Live Updates Modal VR Screen"
                sx={{
                  width: "100%",
                  borderRadius: 1,
                  display: "block",
                  mt: 2,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                className="mx-auto mb-5 bg-gray-100 p-4 rounded-lg shadow-md"
              >
                {[...Array(19)].map((_, index) => (
                  <Grid
                    container
                    spacing={2}
                    alignItems="flex-start"
                    key={index}
                    className="mb-4"
                  >
                    <Grid item xs={1}>
                      <Typography fontWeight="bold">{index + 1}</Typography>
                    </Grid>

                    <Grid item xs={8}>
                      <Typography fontWeight="bold">
                        {t(
                          `operating_manual_portal_live_update_table_header${index + 1}`
                        )}
                      </Typography>
                      <Typography>
                        {t(
                          `operating_manual_portal_live_update_table_content${index + 1}`
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
              <Typography>
                {t("operating_manual_portal_live_appendix_link")}{" "}
                <Link
                  to="/operating-manual/appendix-c-portal-icon-glossary"
                  target="_blank"
                >
                  {t("operating_manual_appendix_c")}
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </div>
      </Box>
    </div>
  );
};

export default LiveUpdatePage;
